export default __webpack_public_path__ + "static/media/3d31ef8d-5c45-40ac-b5b6-e9b09aa84d24.2d9322b2.JPG";